


class TaskImportService {


  static colDefs = [
    { field: 'taskId',  initialWidth: 112 },
    // { field: "reportName", flex: 1, cellRenderer: ReportNameCellRenderer, wrapText: true, autoHeight: true },
    { field: "tenantId" },
    { field: "taskName" },
    { field: "taskType" },
    { field: "taskResult" },
    { field: "status" },
    { field: "serviceName" },
    { field: "serviceParameters" },
    { field: "fileId" },
    { field: "fileMetadata" },
    { field: "fileName" },
    { field: "dateStarted" },
    { field: "dateCompleted" },
    { field: "createdDate" },
    { field: "createdBy" },
    { field: "updatedDate" },
    { field: "updatedBy" },
  

   
 
  ];


};
export default TaskImportService;